// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","navigation__search-icon":"App_navigation__search-icon__1Pt-u"};